import { render, staticRenderFns } from "./InfoClickWin.vue?vue&type=template&id=035dbb33&"
import script from "./InfoClickWin.vue?vue&type=script&lang=js&"
export * from "./InfoClickWin.vue?vue&type=script&lang=js&"
import style0 from "./InfoClickWin.vue?vue&type=style&index=0&id=035dbb33&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports